import React from "react"
import { getIllustration, splitOnMdxType } from "../../utils/mdxTypeUtils"
import style from "./Cards.module.scss"
import { Link } from "gatsby"

export default ({ children, _frontmatter }) => {
  const cards = splitOnMdxType('h2', children)

  return (
    <section className={style.container}>
      {cards.map((card, i) => {
        const { illustration, content, } = getIllustration(card)
        return (
          <article key={i}>
            <Link className={style.card} key={i} to={_frontmatter.links[i]}>
              <div>
                {illustration && <div className={style.illustration}>{illustration}</div>}
                {content}
              </div>
            </Link>
          </article>
        )
      })}
    </section>
  )
}
